import { filtered } from "./filter";
export const unicodeHelperWith = (pairs) => (editor) => {
    const to = editor.getCursor();
    const str = editor.getLine(to.line).slice(0, to.ch);
    const from = { line: to.line, ch: str.lastIndexOf("\\") };
    const typed = editor.getRange({ line: from.line, ch: from.ch + 1 }, to);
    return {
        from,
        to,
        list: !typed
            ? []
            : filtered(pairs, typed, 10).map(([seq, sym]) => ({
                text: sym,
                displayText: `${sym} \\${seq}`,
                hint: (cm) => cm.replaceRange(sym, from, to, "complete"),
            })),
    };
};
//# sourceMappingURL=unicode-helper.js.map